import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../services/users/users.service";
const credentialsKey = 'currentUser';
export class ApplicationService {
    constructor(http, userService) {
        this.http = http;
        this.userService = userService;
        this.tabChange = false;
        this.applicationData = new BehaviorSubject(null);
        this.obsApplicationData = this.applicationData.asObservable();
        this.installerFormOnce = false;
        this.permitType = null;
        this.saveAndExit = false;
    }
    callApplicationAPI(payload) {
        const href = `${environment.application}`;
        return this.http.post(href, payload).pipe(tap((data) => {
            if (data.status === 'success') {
            }
            return data;
        }));
    }
    savePayment(data) {
        const href = `${environment.applicationPayment}`;
        return this.http.post(href, data).pipe(tap((data) => {
            if (data.status === 'success') {
            }
            return data;
        }));
    }
    // openPdf(data): Observable<any> {
    //   const href = `${environment.downloadPermit}`;
    //   return this.http.post<any>(href, data).pipe(
    //     tap(
    //       (data) => {
    //         if (data.status === 'success') {
    //         }
    //         return data;
    //       }
    //     )
    //   );
    // }
    openPdf(id) {
        const href = `${environment.downloadPermit}${id}${'?downloadType=2&exe=1'}`;
        return this.http.get(href).pipe(map((data) => {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    }
    downloadPermit(id, downloadType, exe) {
        let params = new HttpParams();
        params = params.set('downloadType', downloadType);
        params = params.set('exe', exe);
        this.downloadFile = `${environment.host}` + `${environment.downloadPermit}` + `${id}` + `${'?'}` + params.toString();
        window.open(this.downloadFile);
    }
    getApplicationFee(query) {
        const href = `${environment.getApplicationFee}`;
        return this.http.get(href, { params: query }).pipe(tap((data) => {
            if (data.status === 'success') {
                return data;
            }
            return data;
        }));
    }
    searchAddress(searchQuery) {
        const href = environment['searchAddress'];
        return this.http.get(href, { params: searchQuery }).pipe(map((data) => {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    }
    setTabChange(val) {
        this.tabChange = val;
    }
    getTabChange() {
        return this.tabChange;
    }
    setInstallerFormRouteOnce(val) {
        this.installerFormOnce = val;
    }
    getInstallerFormRouteOnce() {
        return this.installerFormOnce;
    }
    setPermitType(val) {
        this.permitType = val;
    }
    getPermitType() {
        return this.permitType;
    }
    setSaveAndExit(val) {
        this.saveAndExit = val;
    }
    getSaveAndExit() {
        return this.saveAndExit;
    }
    setWhatFormData(obj) {
        this.whatFormData = obj;
    }
    getWhatFormData() {
        return this.whatFormData;
    }
    setBurglarInstallerForm(obj) {
        this.burglarInstallerFormData = obj;
    }
    getBurglarInstallerForm() {
        return this.burglarInstallerFormData;
    }
    setFireInstallerForm(obj) {
        this.fireInstallerFormData = obj;
    }
    getFireInstallerForm() {
        return this.fireInstallerFormData;
    }
    verifyCSRFToken(tokenQuery) {
        const href = `${environment.verifyCSRFToken}`;
        return this.http.get(href, { params: tokenQuery }).pipe(map((data) => {
            if (data.status === 'success') {
                const storage = localStorage;
                storage.setItem(credentialsKey, JSON.stringify(data.response));
                this.userService.userDetails.next(data.response);
                return data.response;
            }
        }));
    }
    saveWithoutpayment(payload) {
        const href = `${environment.saveWithoutpayment}`;
        return this.http.post(href, payload).pipe(tap((data) => {
            if (data.status === 'success') {
            }
            return data;
        }));
    }
}
ApplicationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApplicationService_Factory() { return new ApplicationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UsersService)); }, token: ApplicationService, providedIn: "root" });
